<button mat-menu-item [disabled]="isDisabled$ | async" (click)="mergePatient()">
  <mat-icon class="warn">merge</mat-icon>
  <span class="warn">Merge Patient</span>
</button>
